import Swal from "sweetalert2";

/**
 * تأیید رفتن به سوال بعد در حالت فقط به جلو وقتی سوال جاری بدون پاسخ است.
 * @param {'test' | 'descriptive'} examKind
 * @returns {Promise<boolean>} true اگر کاربر تأیید کرد
 */
export function confirmForwardOnlySkipUnanswered(examKind) {
    const isTest = examKind === "test";
    const testHtml = `<div dir="rtl" style="text-align:right;font-size:15px;line-height:1.75;color:#334155;">
        <p style="margin:0;">برای <strong>سوال فعلی هنوز گزینه‌ای انتخاب نشده است</strong>.</p>
        <p style="margin:10px 0 0;font-size:14px;color:#64748b;">در حالت بدون بازگشت، بعد از رفتن به سوال بعد امکان برگشت به این سوال برای انتخاب گزینه وجود ندارد. آیا می‌خواهید ادامه دهید؟</p>
    </div>`;
    const descHtml = `<div dir="rtl" style="text-align:right;font-size:15px;line-height:1.75;color:#334155;">
        <p style="margin:0;">برای <strong>سوال فعلی هنوز متن یا فایلی ثبت نشده است</strong>.</p>
        <p style="margin:10px 0 0;font-size:14px;color:#64748b;">در حالت بدون بازگشت، پس از رفتن به سوال بعد امکان تکمیل این سوال از پاسخنامه وجود ندارد. آیا می‌خواهید ادامه دهید؟</p>
    </div>`;

    return Swal.fire({
        rtl: true,
        icon: "warning",
        iconColor: "#d97706",
        title: "ادامه بدون پاسخ به سوال فعلی؟",
        html: isTest ? testHtml : descHtml,
        showCancelButton: true,
        confirmButtonText: "بله، رفتن به سوال بعد",
        cancelButtonText: "انصراف",
        confirmButtonColor: "#ca8a04",
        cancelButtonColor: "#64748b",
        reverseButtons: true,
        focusCancel: true,
        customClass: { popup: "exam-exit-dialog-popup" },
    }).then((r) => r.isConfirmed === true);
}
